// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"Page_breadcrumbs__1Nc6Q"};